const userInfoKeys = ["token_user", "auth_user", "userId", "uidFibase", "feedbackShowed"]

const logout = () => {
  userInfoKeys.forEach((key) => {
    localStorage.removeItem(key)
  })
}
export {
  logout
}